module.exports = {
  // Where we get our data from
  DATA_URI : 'https://api.xrpintel.com',

  // Ripple Websocket URI
  RIPPLE_WS : "wss://s2.ripple.com:443",

  // Ripple DataV2 API
  RIPPLE_DATAV2_URI : "https://data.ripple.com/v2/",

  // Seconds between retries
  RETRY_SECONDS : 5,

  // Minutes between samples on default report
  REPORT_INTERVAL_MINUTES : 5,

  // Metrics retrieved from default report
  DEFAULT_REPORT_METRICS : [
    "account_rate",
    "fees",
    "ledgers_closed",
    "new_accounts",
    "offers",
    "payments",
    "tx_rate",
    "txs"
  ],

  // Metrices retrieves from timestamp report
  TIMESTAMP_REPORT_METRICS : [
    "account_rate",
    "fees",
    "ledgers_closed",
    "new_accounts",
    "offers",
    "offers_by_currency_pair",
    "payments",
    "payments_by_currency",
    "top_payers",
    "tx_rate",
    "txs"
  ],

  // Navigation Sections
  // TODO 'new txs' section (port from old site)
  NAV_SECTIONS: {
    overview  : {title : 'Overview',  path : '/',         icon : 'graph'},
    ledgers   : {title : 'Ledgers',   path : '/ledgers',  icon : 'clipboard'},
    source    : {title : 'Source',    path : '/source',   icon : 'coding'},
    about     : {title : 'About',     path : '/about',    icon : 'about'},
  },

  ACCOUNT_ROOT_FLAGS : {
    'Rippling'         : 0x00800000,
    'Deposit Auth'     : 0x01000000,
    'Master Disabled'  : 0x00100000,
    'Disallow Xrp'     : 0x00080000,
    'Global Freeze'    : 0x00400000,
    'No Freeze'        : 0x00200000,
    'Password Sent'    : 0x00010000,
    'Require Auth'     : 0x00040000,
    'Require Dest Tag' : 0x00020000
  },

  // TODO other currency unicodes (or replace all w/ SVG icons?)
  CURRENCY_UNICODES : {
    'USD' : '&#36;',
    'CNY' : '&#165;',
    'JPY' : '&#165;',
    'BTC' : '&#8383;',
    'GBP' : '&#163;',
    'EUR' : '&euro;'
  },

  // Number of TXs to retain in history
  TX_HISTORY : 75,

  // From the XRP Protocol
  DROPS_PER_XRP : 1000000,

  // Earliest ledger we can retrieve
  GENESIS_LEDGER : 32570,

  // Timestamp of genesis ledger
  GENESIS_DATETIME : '2013-01-01T03:21:10Z',

  // General TX category for each ledger type
  tx_category_for_type : function(t){
    switch(t){
      case "Payment":
        return "payments";
  
      case "OfferCreate":
      case "OfferCancel":
        return "offers";
  
      case "EscrowCreate":
      case "EscrowFinish":
      case "EscrowCancel":
        return "escrows";
  
      case "PaymentChannelCreate":
      case "PaymentChannelClaim":
      case "PaymentChannelFund":
        return "paychans";
  
      case "AccountSet":
      case "AccountDelete":
      case "SignerListSet":
        return "account_sets";
  
      case "TrustSet":
        return "trust_sets";
  
      default:
        return null;
    }
  }
}
